import { IconButton, mergeStyles, Modal, PrimaryButton, Stack, useTheme } from '@fluentui/react';
import React, { useEffect } from 'react';
import { BaseComponentProps, Input, RemoteMessage } from '..';
import { textConsent } from '../../apps/ZoryveDirect/ZoryveDirect.components';

export const InputPhoneModal = (props: BaseComponentProps): JSX.Element => {
  const { onSubmit } = props;
  const theme = useTheme();
  const [isModalOpen, setIsModalOpen] = React.useState(true);
  const [infoConsentChecked, setInfoConsentChecked] = React.useState(false);
  // const [phoneConsentChecked, setPhoneConsentChecked] = React.useState(false);
  const [submitDisabled, setSubmitDisabled] = React.useState(true);
  const width = Math.min(window.innerWidth, window.outerWidth) - 64;

  useEffect(() => {
    // Diasble body scroll when Modal open
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
    }

    return () => {
      // Enable body scroll when Modal unmounts
      document.body.style.overflow = 'unset';
    };
  }, [isModalOpen]);

  useEffect(() => {
    setSubmitDisabled(!infoConsentChecked);
  }, [infoConsentChecked]);

  const handleOnSubmit = (input: Input) => {
    setIsModalOpen(false);
    onSubmit && onSubmit([input]);
  };

  const handleChange = () => {
    setInfoConsentChecked(!infoConsentChecked);
  };

  if (!isModalOpen) {
    return (
      <RemoteMessage
        text={
          <a
            style={{
              cursor: 'pointer',
              color: theme.palette.black,
              textDecoration: 'underline',
            }}
            onClick={() => setIsModalOpen(true)}
          >
            TEXT ME
          </a>
        }
      ></RemoteMessage>
    );
  }

  return (
    <Modal
      isOpen={isModalOpen}
      styles={{
        main: {
          borderRadius: theme.effects.roundedCorner6,
          overflowY: 'scroll',
          display: 'flex',
          flexDirection: 'column',
        },
      }}
      allowTouchBodyScroll={true}
    >
      <div
        className={mergeStyles({
          padding: '1rem',
          boxShadow: theme.effects.elevation8,
          width: width,
          borderRadius: `${theme.effects.roundedCorner6} ${theme.effects.roundedCorner6} 0 0`,
          background: theme.palette.neutralPrimary,
        })}
      >
        <Stack
          style={{
            height: '100%',
            color: 'black',
            paddingBottom: '0rem',
            overflowY: 'scroll',
          }}
        >
          <Stack horizontal horizontalAlign="space-between" verticalAlign="center">
            <h3
              style={{
                color: 'black',
                fontSize: '14px',
                margin: 0,
                paddingBottom: '0rem',
              }}
            >
              TEXT MY SAVINGS CARD TO ME AND SIGN UP FOR ADDITIONAL UPDATES
            </h3>

            <IconButton
              style={{
                color: theme.palette.neutralLight,
                fontSize: '6px',
                position: 'sticky',
                float: 'right',
                top: 0,
              }}
              iconProps={{ iconName: 'Cancel' }}
              ariaLabel="Close popup modal"
              onClick={() => setIsModalOpen(false)}
            />
          </Stack>
          <div
            style={{
              maxHeight: window.innerHeight / 1.5,
              overflow: 'auto',
              paddingTop: '0.5rem',
              paddingBottom: '1rem',
              fontSize: '11px',
              fontWeight: 400,
            }}
          >
            {textConsent}
            <Stack
              horizontal
              horizontalAlign="start"
              style={{ paddingTop: '0.8rem', paddingBottom: '1rem' }}
            >
              <input
                type="checkbox"
                id="infoConsent"
                name="infoConsent"
                checked={infoConsentChecked}
                onChange={handleChange}
                style={{
                  minWidth: '1.5rem',
                  minHeight: '1.5rem',
                  borderRadius: theme.effects.roundedCorner6,
                }}
              />
              <Stack horizontalAlign="start" verticalAlign="center">
                <label htmlFor="textTerms" style={{ marginLeft: '0.5rem', fontSize: '12px' }}>
                  I have read and agree to the{' '}
                  <a
                    style={{ color: 'black' }}
                    href="https://www.arcutis.com/privacy/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Text Messaging Terms and Conditions
                  </a>{' '}
                  and agree to receive text messages
                </label>
              </Stack>
            </Stack>
          </div>
        </Stack>

        <Stack horizontal horizontalAlign="center" style={{ padding: '0.5rem' }}>
          <PrimaryButton
            className={mergeStyles({
              height: '2.5rem',
              minWidth: '8rem',
              borderRadius: theme.effects.roundedCorner6,
              boxShadow: theme.effects.elevation8,
              fontSize: '16px',
              color: theme.palette.neutralLight,
              background: theme.palette.themePrimary,
              ':disabled': {
                background: '#faecc0',
                color: '#c0bdb5',
              },
            })}
            disabled={submitDisabled}
            onClick={() =>
              handleOnSubmit({
                id: '1',
                name: 'textTerms',
                key: 'TEXT_TERMS',
                value: 'I Agree',
              })
            }
          >
            SUBMIT
          </PrimaryButton>
        </Stack>
      </div>
    </Modal>
  );
};
